import React, { useEffect, useState } from "react";
import {
    Button,
    CardActionArea,
    CardContent,
    colors,
    Container,
    Grid,
    Hidden,
    LinearProgress,
    makeStyles,
    Paper,
    Table,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";

import ScannerIcon from "@material-ui/icons/Scanner";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import PrintIcon from "@material-ui/icons/Print";
import {
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../../St/Reports/UseStyle";
import moment from "moment";
import { insh as inshst } from "../../../../Context/InshSt";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { CSVLink } from "react-csv";
import { TableChart } from "@material-ui/icons";
import {
    aMdefaultValues,
    excelHeaders,
} from "../../../../services/accMasn-services";
import SelectTypesFilter from "../MainRBalance/MainRBalance-typeFilter";
import AccountSystemTotals from "./AccountSystemTotals";
import AccountsSystemForm from "./AccountsSystemForm";
import AccountsSystemTable from "./AccountsSystemTable";
import AccountsSystemFilter from "./AccountsSystemFilter";
import { uri } from "../../../../help/Api";
import toast from "react-hot-toast";
import ReviewMezanPrint from "../../../../Reviews/Accounts/mezanPrint/RevMezanPrint";
import { exportExcelReport } from "../../../../components/ExcelExport";
import CheckRestrictions from "./CheckRestrictions/CheckRestrictions";

const useStyles = makeStyles((theme) => ({
    root: {
        borderColor: "#808080",
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },

    headerTitle: {
        borderColor: "#808080",
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        fontWeight: "bold"
    },

    blCard: {
        backgroundColor: "#d3d3d3",
        borderColor: "#898989",
    },
    root3: {
        flexGrow: 1,
        width: "100%",
        borderColor: "#808080",
        direction: "rtl",
        marginTop: 5,
        padding: 5,
        boxShadow:
            "rgba(67, 71, 85, 0.27) 0px 0px 0.25em, rgba(90, 125, 188, 0.05) 0px 0.25em 1em;",
    },
}));

export default function AccountsSystem(props) {
    const { AutoOptions } = props;
    let from_date = moment(new Date()).subtract().format("YYYY") + "-01-01";
    const [rptParams, setRptParams] = React.useState({
        ...aMdefaultValues,
        dateFrom: from_date,
    });
    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();

    const [data, setData] = useState([]);
    const [totals, setTotals] = useState({});

    const [fetching, setFetching] = useState(false);

    const viewHandle = async () => {
        setData([]);
        setFetching(true);
        if (rptParams.type.no == 3) {
            await axios
                .get(
                    uri +
                    `AccountReports/rptAccMasnDakhel?dateFrom=${rptParams.dateFrom}
    &&dateTo=${rptParams.dateTo}
    &&branch=${rptParams.branch.id}
    &&center=${rptParams.center.id}
    &&finalAcc=${rptParams.type.finalAcc}
    &&type=${rptParams.type.name}
    &&level=${rptParams.level.id}
    &&acc_no=${""}
    &&chkPrev=${rptParams.chkPrev}
    &&type_cost=${rptParams.type_cost.id}
    &&no_stock=${rptParams.no_stock}
    &&acc_type=${rptParams.level.type}&&hide_zero=${rptParams.hide_zero_balance}`
                )
                .then((res) => {
                    setData(res.data);
                    console.log(" the data is", res.data);
                    setFetching(false);
                })
                .catch((err) => {
                    viewHandleNew();
                });
        } else {
            await axios
                .get(
                    uri +
                    `AccountReports/rptAccMasn?dateFrom=${rptParams.dateFrom}
    &&dateTo=${rptParams.dateTo}
    &&branch=${rptParams.branch.id}
    &&center=${rptParams.center.id}
    &&finalAcc=${rptParams.type.finalAcc}
    &&type=${rptParams.type.name}
    &&level=${rptParams.level.id}
    &&acc_no=${""}
    &&chkPrev=${rptParams.chkPrev}
    &&type_cost=${rptParams.type_cost.id}
    &&no_stock=${rptParams.no_stock}
    &&acc_type=${rptParams.level.type}`
                )
                .then((res) => {
                    setData(res.data);
                    console.log(" the data is", res.data);
                    setFetching(false);
                })
                .catch((err) => {
                    viewHandleNew();
                });
        }

    };
    const viewHandleOld = async () => {
        setData([]);
        setFetching(true);
        await axios
            .get(
                uri +
                `AccountReports/rptAccMasn?dateFrom=${rptParams.dateFrom}
    &&dateTo=${rptParams.dateTo}
    &&branch=${rptParams.branch.id}
    &&center=${rptParams.center.id}
    &&finalAcc=${rptParams.type.finalAcc}
    &&type=${rptParams.type.name}
    &&level=${rptParams.level.id}
    &&acc_no=${""}
    &&chkPrev=${rptParams.chkPrev}
    &&type_cost=${rptParams.type_cost.id}
    &&no_stock=${rptParams.no_stock}
    &&acc_type=${rptParams.level.type}`
            )
            .then((res) => {
                setData(res.data);
                console.log(" the data is", res.data);
                setFetching(false);
            })
            .catch((err) => {
                viewHandleNew();
            });
    };
    const viewHandleNew = async () => {
        setData([]);
        setFetching(true);
        await axios
            .get(
                uri +
                `AccountReports/rptAccMasn?dateFrom=${rptParams.dateFrom}
    &&dateTo=${rptParams.dateTo}
    &&branch=${rptParams.branch.id}
    &&center=${rptParams.center.id}
    &&finalAcc=${rptParams.type.finalAcc}
    &&type=${rptParams.type.name}
    &&level=${rptParams.level.id}
    &&acc_no=${""}
    &&chkPrev=${rptParams.chkPrev}
    &&type_cost=${rptParams.type_cost.id}
    &&no_stock=${rptParams.no_stock}
    &&acc_type=${rptParams.level.type}&&hide_zero=${rptParams.hide_zero_balance}`
            )
            .then((res) => {
                setData(res.data);
                console.log(" the data is", res.data);
                setFetching(false);
            })
            .catch((err) => {
                setFetching(false);
                console.log(err);
                // toast.err("يوجد خطأ في الجلب");
                setData([]);
            });
    };
    const [style, setStyle] = useState(inshst.custm);
    const { t } = useTranslation(["forms"]);
    useEffect(() => {
        console.log(" the balance ", data);
    }, []);
    const his = useHistory();
    const toBack = () => {
        his.push({ pathname: "/" });
    };
    const [dataPrint, setDataPrint] = useState({});
    const [infoPrint, setInfoPrint] = useState(false);
    const closePrint = (type) => {
        setDataPrint({});
        setInfoPrint(false);
    };

    const printHandle = () => {
        const nData = rptParams.level?.id === -1 ? data.filter((d) => parseInt(d?.ac) > 12345) : data;
        const info = {
            data: data,
            // totals: data,
            tot: {
                prevDept: nData
                    .reduce((a, v) => (a = a + parseFloat(v.OB_DR_AMT_L)), 0)
                    .toFixed(2),
                prevCredit: nData
                    .reduce((a, v) => (a = a + parseFloat(v.OB_CR_AMT_L)), 0)
                    .toFixed(2),
                moveDept: nData
                    .reduce((a, v) => (a = a + parseFloat(v.DR_AMT_L)), 0)
                    .toFixed(2),
                moveCredit: nData
                    .reduce((a, v) => (a = a + parseFloat(v.CR_AMT_L)), 0)
                    .toFixed(2),
                balDept: nData
                    .reduce((a, v) => (a = a + parseFloat(v.End_DR_AMT_L)), 0)
                    .toFixed(2),
                balCredit: nData
                    .reduce((a, v) => (a = a + parseFloat(v.End_CR_AMT_L)), 0)
                    .toFixed(2)
            },
            dateFrom: rptParams.dateFrom,
            dateTo: rptParams.dateTo,
            title: t(rptParams.type.label) + " خلال فترة",
            nDate: moment(new Date()).format("YYYY-MM-DD"),
            type: rptParams.type.id,
        };
        setDataPrint(info);
        setInfoPrint(true);
        // localStorage.setItem("iInfos", JSON.stringify(info));
        // his.push({ pathname: "/MainRBalanceRpint" });
        // window.location.reload(true);
    };
    let excel_name = "";
    excel_name = "MezanReports"


    const onChangeData = (propName) => (event) => {
        setRptParams({ ...rptParams, [propName]: event.target.value });
    };
    const onChangeAutoData = (propName, newValue) => {
        setRptParams({ ...rptParams, [propName]: newValue });
    };

    const Export_excel = () => {
        exportExcelReport({
            title: t(rptParams.type.label) + " خلال فترة" + "  " + "من تاريخ" + "  :" + rptParams.dateFrom + "  " + "إلى تاريخ" + "   :" + rptParams.dateTo,
            info: [
                {
                    label: "من تاريخ",
                    value: rptParams.dateFrom
                },
                {
                    label: "إلى تاريخ",
                    value: rptParams.dateTo
                },
                //   {
                //     label: "الفرع",
                //     value: rptParams.branch.name
                //   },
            ],
            columns: [
                {
                    title: "م",
                    field: "__index",
                    width: 7
                },
                {
                    title: "رقم الحساب",
                    field: "ac",
                    width: 15
                },
                {
                    title: "الحساب",
                    field: "AName",
                    width: 18
                },
                {
                    title: "مدين (افتتاحي)",
                    field: "val_open_dept",
                    width: 18
                },
                {
                    title: "دائن (افتتاحي)",
                    field: "val_open_credit",
                    width: 18,
                    type: "number"
                },
                {
                    title: "مدين (سابق)",
                    field: "OB_DR_AMT_L",
                    width: 18,
                    type: "number"
                },
                {
                    title: "دائن (سابق)",
                    field: "OB_CR_AMT_L",
                    width: 15,
                    type: "number"
                },
                {
                    title: "مدين (حركة)",
                    field: "DR_AMT_L",
                    width: 15,
                    type: "number"
                },
                {
                    title: "دائن (حركة)",
                    field: "CR_AMT_L",
                    width: 18,
                    type: "number"
                },
                {
                    title: "مدين (رصيد)",
                    field: "End_DR_AMT_L",
                    width: 18,
                    type: "number"
                },
                {
                    title: "دائن (رصيد)",
                    field: "End_CR_AMT_L",
                    width: 18,
                    type: "number"
                }
            ],

            data: data,

            totals: [
                {
                    label: "إجمالي المدين",
                    field: "End_DR_AMT_L"
                },
                {
                    label: "إجمالي الدائن",
                    field: "End_CR_AMT_L"
                }
            ],

            fileName: t(rptParams.type.label) + " خلال فترة",

            sheetName: t(rptParams.type.label) + " خلال فترة",

            showSerial: false,

            showFilter: true,

            freezeHeader: true,

            rightToLeft: true
        });

    }; // E rsa
    const [openCheck, setOpenCheck] = useState(false);
    const [database, setDatabase] = useState({});

    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography size="small" className={classes.headerTitle}>
                    {"تقرير نظام الحسابات"}
                </Typography>
            </Grid>
            <Typography component="div" style={{ direction: "rtl" }}>
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: inshst.colors.acc,
                        borderBottomWidth: "10px",
                        borderBottomStyle: "solid",
                    }}
                >
                    <AccountsSystemFilter {...{ rptParams, setRptParams }} />

                    <AccountsSystemForm
                        {...{
                            AutoOptions,
                            rptParams,
                            setRptParams,
                            onChangeData,
                            onChangeAutoData,
                            printHandle,
                        }}
                    />
                    <Grid
                        container
                        justifyContent="center"
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        spacing={1}
                    >
                        <Hidden only={["xs"]}>
                            <Grid item>
                                <Button
                                    disabled={fetching}
                                    variant="contained"
                                    startIcon={<ScannerIcon />}
                                    size="large"
                                    style={
                                        (inshst.sal.iconBtnAcc,
                                            { borderRadius: 0 })
                                    }
                                    className={[clasui.buttonAcc]}
                                    onClick={viewHandle}
                                >
                                    {t("forms:view")}
                                </Button>
                            </Grid>
                        </Hidden>

                        <Hidden smUp={["sm"]}>
                            <Grid item>
                                <Button
                                    disabled={fetching}
                                    variant="contained"
                                    startIcon={<ScannerIcon />}
                                    size="large"
                                    style={
                                        (inshst.sal.iconBtnAcc,
                                            { borderRadius: 0 })
                                    }
                                    className={[clasui.buttonAcc]}
                                    onClick={viewHandle}
                                >
                                    {t("forms:show")}
                                </Button>
                            </Grid>
                        </Hidden>
                        <Hidden only={["xs"]}>

                            <Grid item >
                                {data && !fetching && data && (
                                    <Grid item>
                                        <Button
                                            disabled={fetching}
                                            variant="contained"
                                            startIcon={<TableChart />}
                                            color="primary"
                                            size="large"
                                            className={clasui.buttonAcc}
                                            onClick={Export_excel}
                                        >
                                            {"تصدير اكسل"}{" "}
                                        </Button>
                                    </Grid>
                                )}
                            </Grid>
                        </Hidden>
                        <Hidden smUp={["sm"]}>
                            <Grid item >
                                {data && !fetching && data && (
                                    <Grid item>
                                        <Button
                                            disabled={fetching}
                                            variant="contained"
                                            startIcon={<TableChart />}
                                            color="primary"
                                            size="large"
                                            className={clasui.buttonAcc}
                                            onClick={Export_excel}
                                        >
                                            {"اكسل"}{" "}
                                        </Button>
                                    </Grid>
                                )}
                            </Grid>
                        </Hidden>
                        <Grid item>
                            <Button
                                variant="contained"
                                startIcon={<PrintIcon />}
                                color="primary"
                                size="large"
                                style={
                                    (inshst.sal.iconBtnAcc,
                                        { borderRadius: 0 })
                                }
                                className={[clasui.buttonAcc]}
                                // disabled={true}
                                onClick={printHandle}
                            >
                                {t("forms:print")}{" "}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                startIcon={<KeyboardReturnSharpIcon />}
                                color="secondary"
                                size="large"
                                className={[clasui.button, clasSp.clcan]}
                                style={
                                    (inshst.sal.iconBtn,
                                        { borderRadius: 0 })
                                }
                                onClick={toBack}
                            >
                                {t("forms:exit")}
                            </Button>
                        </Grid>
                    </Grid>
                </Container>
                <Container maxWidth={true} style={{ padding: "4px" }}>
                    {!fetching && (
                        <AccountSystemTotals
                            {...{
                                data: data ? data : [],
                                isMoragaa: rptParams.type.id == 3,
                                level: rptParams.level.id,
                            }}
                        />
                    )}
                </Container>
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        // paddingTop:'5px',
                    }}
                >
                    <Grid container>
                        {fetching ? (
                            <TableContainer component={Paper}>
                                {"يرجى الانتظار قليلا حتى يتم جلب البيانات ..."}
                                <LinearProgress />
                            </TableContainer>
                        ) : (
                            <AccountsSystemTable {...{
                                data: data ? data : [],
                                isMoragaa: rptParams.type.id == 3,
                                level: rptParams.level.id,
                            }} />

                        )}
                        {infoPrint ? <ReviewMezanPrint dataPrint={dataPrint} closePrint={closePrint} infoPrint={infoPrint} /> : null}

                    </Grid>
                </Container>
            </Typography>
            {openCheck &&
                <CheckRestrictions
                    openCheck={openCheck}
                    setOpenCheck={setOpenCheck}
                    rptParams={rptParams}
                    database={database}
                    AutoOptions={AutoOptions}
                />
            }
        </div>
    );
}
